import { useEffect, useRef, useState } from 'react'
import { searchLocations } from '../api/geocode'
import {
  LOCATION_MODAL,
  GEOCODE,
  type LocationSuggestion,
} from '../constants/location'

export function useLocationSearch(query: string, enabled: boolean) {
  const [suggestions, setSuggestions] = useState<LocationSuggestion[]>([])
  const [isSearching, setIsSearching] = useState(false)
  const [searchError, setSearchError] = useState<string | null>(null)
  const requestId = useRef(0)

  useEffect(() => {
    if (!enabled) {
      requestId.current += 1
      setSuggestions([])
      setIsSearching(false)
      setSearchError(null)
      return
    }

    const normalized = query.trim()
    if (normalized.length < 2) {
      requestId.current += 1
      setSuggestions([])
      setIsSearching(false)
      setSearchError(null)
      return
    }

    const id = ++requestId.current
    setIsSearching(true)
    setSearchError(null)

    const timer = window.setTimeout(() => {
      void searchLocations(normalized)
        .then((results) => {
          if (requestId.current !== id) return
          setSuggestions(results)
        })
        .catch(() => {
          if (requestId.current !== id) return
          setSuggestions([])
          setSearchError(LOCATION_MODAL.searchFailed)
        })
        .finally(() => {
          if (requestId.current !== id) return
          setIsSearching(false)
        })
    }, GEOCODE.searchDebounceMs)

    return () => {
      window.clearTimeout(timer)
    }
  }, [query, enabled])

  return { suggestions, isSearching, searchError }
}
